import React from 'react';
import styled from 'styled-components';
import { trackLinkClick } from 'utilities';

type HrefTarget = '_blank' | '_self' | '_parent' | '_top';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  dataTestId?: string;
  href?: string;
  target?: HrefTarget;
  ariaLabel?: string;
  onClick?: (() => void) | null;
  gaLinkType?: string;
}

const Link = ({
  className,
  children,
  dataTestId,
  href,
  target = '_blank',
  ariaLabel,
  onClick,
  gaLinkType
}: IProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (gaLinkType) trackLinkClick(gaLinkType);
    if (!onClick) return;

    // in case onClick is passed, we execute the click func and not the href redirect
    e.preventDefault();
    onClick();
  };

  // when undefined, the a tag will not have an href attribute at all..
  // so when hovering on the link we will not see an href that will not work as expected
  const calculatedHref = onClick ? undefined : href;

  return (
    <StyledLink
      className={className}
      target={target}
      href={calculatedHref}
      rel="noopener noreferrer"
      onClick={handleClick}
      data-test-id={dataTestId || undefined}
      aria-label={ariaLabel || undefined}
    >
      {children}
    </StyledLink>
  );
};

export default Link;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.link.primary};
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
`;
